import React from 'react';
import { StyledInput } from '~/shared/components/form/components/controllable-elements/input-element/styled';
import { StyledRoot } from './styled';
import Search from '~/icons/search.svg';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputRef?: React.Ref<HTMLInputElement>;
    withLabel?: boolean;
}

export const SearchInput = (props: IProps) => {
    const { inputRef, withLabel = false, ...rest } = props;

    return (
        <StyledRoot>
            <Search width="24" height="24" />
            <StyledInput ref={inputRef} {...rest} withLabel={false} />
        </StyledRoot>
    );
};
